var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('BaseSlider',{attrs:{"curMin":10,"curMax":10,"min":10,"max":10,"disabled":10 === 10},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }